<template>
	<div>
		<v-card>
			<v-container grid-list-xs fluid>
				<v-layout row wrap justify-center>
					<v-flex xs12 md6>
						<v-card color="blue lighten-1" flat dark>
							<v-card-text class="text-center">
								<span class="white--text">Tổng số tiền đã thu:</span>
								<div class="headline">{{calcTotalAmount(receipts) | formatNumber}} VND</div>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs12 md6>
						<v-card color="orange lighten-1" flat dark>
							<v-card-text class="text-center">
								<span class="white--text">Tổng số tiền chênh lệch:</span>
								<div class="headline">{{calcDiffAmount(receipts) | formatNumber}} VND</div>
							</v-card-text>
						</v-card>
					</v-flex>
					<v-flex xs12 offset-md6 md2>
						<v-text-field
							v-model="search"
							prepend-icon="search"
							label="Tìm kiếm"
							hide-details
						></v-text-field>
					</v-flex>
					<v-flex xs12 md2>
							<v-btn
								@click="exportCSVPhieuChiTiet"
								:loading="export_detail_csv.loading"
								:disabled="export_detail_csv.loading"
								color="green"
								class="white--text">
									XUẤT EXCEL PHIẾU CHI TIẾT
							</v-btn>
							<export-csv-button
									:trigger="export_detail_csv.trigger"
									:title="export_detail_csv.title"
									:rows="export_detail_csv.rows"
							></export-csv-button>
					</v-flex>
					<v-flex xs12 md2>
							<v-btn
								@click="exportCSVPhieuCG"
								:loading="export_cg_csv.loading"
								:disabled="export_cg_csv.loading"
								color="green"
								class="white--text">
									XUẤT EXCEL PHIẾU CG
								</v-btn>
							<export-csv-button
									:trigger="export_cg_csv.trigger"
									:title="export_cg_csv.title"
									:rows="export_cg_csv.rows"
							></export-csv-button>
					</v-flex>
					<v-flex xs12>
						<v-card>
							<v-data-table
								:headers="headers"
								:items="receipts"
								:rows-per-page-items="rowPerPage"
								disable-initial-sort
								class="elevation-1"
								:search="search"
							>
								<template v-slot:items="props">
									<tr>
                                        <td class="text-no-wrap">
											<v-menu offset-y>
												<template v-slot:activator="{ on }">
													<v-btn icon v-on="on">
														<v-icon small color="#464D69">settings</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-tile
														@click="selected_receipt = props.item; dialog_detail = !dialog_detail"
													>
														<v-list-tile-action>
															<v-icon small class="zmdi zmdi-assignment"></v-icon>
														</v-list-tile-action>
														<v-list-tile-title>
															Chi tiết
														</v-list-tile-title>
													</v-list-tile>
													<v-list-tile
														@click="selected_receipt = props.item; trigger_edit_component = !trigger_edit_component;"
													>
														<v-list-tile-action>
															<v-icon small class="zmdi zmdi-edit"></v-icon>
														</v-list-tile-action>
														<v-list-tile-title>
															Chỉnh sửa
														</v-list-tile-title>
													</v-list-tile>
												</v-list>
											</v-menu>
                                        </td>
										<td class="text-xs-center">{{ props.item.receipt_id }}</td>
										<td class="text-xs-center">{{ props.item.date_collected | formatTimeServer}}</td>
										<td class="text-xs-center">{{ props.item.receipt_count }}</td>
										<td class="text-xs-right">{{ props.item.total_amount_selected | formatNumber }}</td>
										<td class="text-xs-right">{{ props.item.total_amount_collected | formatNumber }}</td>
										<td class="text-xs-center">{{ props.item.collector }}</td>
										<td class="text-xs-right">{{ props.item.diff_amount | formatNumber }}</td>
									</tr>
								</template>
							</v-data-table>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-card>
		<v-dialog v-model="dialog_detail" transition="dialog-transition">
			<dialog-phieu-chi-tiet :selected_receipt="selected_receipt"></dialog-phieu-chi-tiet>
		</v-dialog>
		<edit-receipt-component
			title="CHỈNH SỬA PHIẾU CG"
            hide_button
			@updateCurrentReceipt="updateCurrentReceipt"
			receipt_type="collected"
            :trigger="trigger_edit_component"
			:edit_field="edit_field"
			:selected_receipt="selected_receipt"
		></edit-receipt-component>
	</div>
</template>
<script>
import api from "Api";
import DialogPhieuChiTiet from "./DialogPhieuChiTiet";
import { dayDiff, buildParamQuery, formatTimeServer } from "Helpers";
import EditReceiptComponent from 'Components/Phieu/EditReceiptComponent'
import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton'

const list_collectors = [
			{ text: 'BVBN', value: 'BVBN'},
			{ text: 'BVGB', value: 'BVGB'},
			{ text: 'BVTT', value: 'BVTT'},
			{ text: 'BVXA', value: 'BVXA'},
			{ text: 'BVMA', value: 'BVMA'},
			{ text: 'BVBMT', value: 'BVBMT'}
		];

export default {
	name: "tab-phieu-thu-co-gam",
	props: {
		current_tab: Number
	},
	components: {
		DialogPhieuChiTiet,
		EditReceiptComponent,
		ExportCsvButton
	},
	data: () => ({
		loader: false,
		rowPerPage: [20, 50, 100, { text: "Tất cả", value: -1 }],
		selected_receipt: {},
		dialog_detail: false,
		headers: [
			{ text: "Thao tác", sortable: false, value: "receipt_id", align: "center" },
			{
				text: "Mã số phiếu",
				value: "receipt_id",
				align: "center"
			},
			{ text: "Ngày thu", value: "date_collected", align: "center" },
			{
				text: "Số phiếu chi tiết",
				value: "receipt_count",
				align: "center"
			},
			{
				text: "Số tiền phải thu",
				value: "total_amount_selected",
				align: "right"
			},
			{
				text: "Số tiền thực thu",
				value: "total_amount_collected",
				align: "right"
			},
			{ text: "Bảo vệ", value: "collector", align: "center" },
			{ text: "Chênh lệch", value: "diff_amount", align: "right" }
		],
		receipts: [],
		edit_field: {
			receipt_id: {
				type: "text",
				flex_attr: "xs12 md3",
				label: "Số chứng từ",
				disabled: false,
				prepend_icon: "book",
				rule: "require"
			},
			collector: {
				type: "list",
				flex_attr: "xs12 sm3",
				label: "Bảo vệ:",
				disabled: false,
				items: list_collectors,
				prepend_icon: "domain",
				rule: "require",
			},
			date_collected: {
				type: "date",
				flex_attr: "xs12 md3",
				label: "Ngày thu",
				disabled: false,
				prepend_icon: "event",
				rule: "require"
			},
			note: {
				type: "text",
				flex_attr: "xs12 md3",
				label: "Giải thích chỉnh sửa",
				disabled: false,
				prepend_icon: "event_note",
				rule: "require"
			},
		},
		trigger_edit_component: false,
		search: '',
		receipt_text: {
			"ROOM": "Phiếu thu tiền phòng",
			"OTHER": "Phiếu thu khác",
			"DEPOSIT": "Phiếu cọc",
			"DIFFERENCE": "Chênh lệch của phiếu CG "
		},
		export_cg_csv: {
			loading: false,
			trigger: false,
			title: "",
			rows: []
		},
		export_detail_csv: {
			loading: false,
			trigger: false,
			title: "",
			rows: []
		},
	}),
	watch: {
		current_tab() {
			if (this.current_tab === 1) this.getReceiptData();
		}
	},
	created() {},
	methods: {
		async getReceiptData() {
			this.loader = true;
			this.receipts = [];
			const data = await api.getListReceiptCollected();
			if (data.status == 200) {
				this.receipts = data.data.map(receipt => {
					return receipt;
				});
			}
		},
		calcTotalAmount: arr =>
			arr.reduce(
				(accumulator, currentReceipt) =>
					accumulator + currentReceipt.total_amount_collected,
				0
			),
		calcDiffAmount: arr =>
			arr.reduce(
				(accumulator, currentReceipt) =>
					accumulator + (currentReceipt.diff_amount || 0),
				0
			),
		updateCurrentReceipt(_id, updated_field){
				const selected_receipt = this.receipts.find(receipt => receipt._id === _id);
				for (const key in updated_field) {
						if (updated_field.hasOwnProperty(key)) {
								const element = updated_field[key];
								selected_receipt[key] = element;
						}
				}
		},
    async getAllDetailReceiptsData() {
      this.loader = true;

      const receiptRoomAndOther = await api.getReceiptRoomAndOther();
      const receiptDeposit = await api.getDepositReceipts();
      const receiptDifference = await api.getReceiptDifference();

      const results = [
        ...receiptRoomAndOther.data,
        ...receiptDeposit.data,
        ...receiptDifference.data,
      ]
				.filter(receipt => !!receipt.receipt_collected_id)
        .map((receipt, index) => {
          receipt.type = receipt.month
            ? receipt.room_id
              ? "ROOM"
              : "OTHER"
            : receipt.date_deposit
            ? "DEPOSIT"
            : "DIFFERENCE";

          if (receipt.type === "ROOM" || receipt.type === "OTHER") {
            receipt.receipt_date = receipt.date_collected;
            receipt.receipt_amount = receipt.collected_amount;
            receipt.title = this.receipt_text[receipt.type];
          } else if (receipt.type === "DEPOSIT") {
            receipt.receipt_date = receipt.date_deposit;
            receipt.receipt_amount = receipt.deposit_amount;
            receipt.title = this.receipt_text[receipt.type];
          } else if (receipt.type === "DIFFERENCE") {
            receipt.receipt_date = receipt.date_collected;
            receipt.receipt_amount = receipt.collected_amount;
            receipt.title =
              this.receipt_text[receipt.type] +
              receipt.created_by_receipt_collected_id;
          }

          return {
            STT: index + 1,
            "Loại phiếu": receipt.title,
            "Mã số phiếu": receipt.receipt_id,
            "Ngày tạo": formatTimeServer(receipt.receipt_date),
            "Số phòng": receipt.room_id,
            "Số tiền": receipt.receipt_amount,
            "Bảo vệ": receipt.collector,
            "Ghi chú": receipt.note,
            "Phiếu Cô Gấm": receipt.receipt_collected_id,
          };
        })
        .sort((a, b) => {
				  const valueA = a["Phiếu Cô Gấm"].toUpperCase(); // ignore upper and lowercase
					const valueB = b["Phiếu Cô Gấm"].toUpperCase(); // ignore upper and lowercase

					if (valueA < valueB) {
						return -1;
					}

					if (valueA > valueB) {
						return 1;
					}
					return 0;
				});

      this.loader = false;

      return results;
    },
		exportCSVPhieuChiTiet: async function (){
			this.export_detail_csv.loading = true;

			this.export_detail_csv.rows = await this.getAllDetailReceiptsData()
		
			const date = new Date().toISOString().substring(0, 10)
			this.export_detail_csv.title = "phieu-thu-chi-tiet-" + date;
			this.export_detail_csv.trigger = !this.export_detail_csv.trigger;
			this.export_detail_csv.loading = false;
		},
		exportCSVPhieuCG: function(){
			this.export_cg_csv.loading = true;
			const rows = this.receipts.map((item, index) => {
				return {
					"STT": index + 1,
					"Mã số phiếu": item.receipt_id,
					"Ngày thu": formatTimeServer(item.date_collected),
					"Số phiếu chi tiết": item.receipt_count,
					"Số tiền phải thu": item.total_amount_selected,
					"Số tiền thực thu": item.total_amount_collected,
					"Bảo vệ": item.collector,
					"Chênh lệch": item.diff_amount,
				}
			})
			this.export_cg_csv.rows = rows;
			const date = new Date().toISOString().substring(0, 10)
			this.export_cg_csv.title = "phieu-thu-co-gam-" + date;
			this.export_cg_csv.trigger = !this.export_cg_csv.trigger;
			this.export_cg_csv.loading = false;
		}
	}
};
</script>
<style scoped>
    .v-list__tile__action {
        min-width: 30px;
    }
</style>